export default __webpack_public_path__ + "static/media/user.506fe529.png";